const SlektClient = require('@optionq/slekt-client')
const slektClient = new SlektClient('slekt-client', 'http://localhost:3000/')

module.exports = slektClient
